module.exports = __webpack_public_path__ + "static/media/cover2.1e7a88c2.png";